<template>
	<div class="mask" id="dyDialog" v-if="visible" 
		:class="{animate__animated:true, animate__fadeIn:visible}" 
		:style={zIndex:data.zIndex}
		@mousedown="cancel(null, true)">
		
		<div class="dialog popIn" @mousedown.stop :class="{animate__animated:true, animate__zoomIn:visible, fit:data.fit}" :style="{width:data.width||'auto', height:data.height||'auto'}">
			<div class="dialog-title" v-if="!data.hideTitle">
				<div>{{data.title}}</div>
				<div class="dialog-subtitle">{{data.subtitle}}</div>
				
				<dy-input 
					id="title-input" 
					type="text" 
					v-if="data.titleInput" 
					v-model="search_word" 
					:number="false" 
					:list="data.titleInputList"
					:placeholder="data.titlePlaceholder"
					:class="'title-input ' + (data.titleInputClass || '')" 
					@clearInput="data.clearInput"
					@input="data.onInput"></dy-input>
					
				<!-- 文字类型按钮 -->
				<dy-button class="title-text-btn" :style="'margin-left:'+(index==0?'20px':'0px')" 
					v-for="(item,index) in data.titleBtnArr" :key="index" 
					:tooltip="item.tip?item.tip:''"
					@click="item.click&&item.click()">{{item.name}}</dy-button>
				<div v-if="(data.buttonAlign=='right'||!data.buttonAlign) && !data.titleText" style="flex: 1;"></div>
				
				<!-- 功能按钮 -->
				<dy-button v-if="data.titleButton" 
					class="dialog-title-button active" 
					:tooltip="data.titleBtnTip ? data.titleBtnTip : ''"
					:class="(data.titleInput&&search_word=='')||data.titleButtonDisable ? 'disable' : ''"
					@click="!((data.titleInput&&search_word=='')||data.titleButtonDisable) && data.titleButtonClick(search_word)">
					<dy-icon v-if="data.iconClass" :class="data.iconClass"></dy-icon>{{data.titleButtonText}}
				</dy-button>
				
				<!-- 显示的文字（目前使用：高德地图点位坐标提示） -->
				<div class="title-text" :style="data.titleTextStyle" v-if="data.titleText" @click="data.titleTextClick">{{data.titleText}}
					<span allowSelected="true">{{data.titleTextData}}</span>
					<span style="color: rgb(99, 120, 231);cursor: pointer;margin-left: 5px;" v-if="data.titleTextBtn" @click="data.titleTextBtnClick">{{data.titleTextBtnText?data.titleTextBtnText:'去开通'}}</span>
				</div>
				
				<div v-if="data.buttonAlign=='left' && !data.titleText" style="flex: 1;"></div>
				<dy-icon class="button_close" v-if="!data.hideClose" icon="icon-error-filled" tooltip="关闭" @click="cancel"></dy-icon>
			</div>
			
			<div class="dialog-container" :class="{'onlyImg':data.onlyImg}" @scroll="data.onScroll">
				<dy-icon v-if="data.containerClose" 
					class="button_close" 
					icon="icon-close-small" 
					style="position: absolute;right: 5px;top: 0px;"
					tooltip="关闭" @click="cancel"></dy-icon>
				<slot v-if="!data.content" :data="data"></slot>
				<div v-else="data.content" >
					<div class="title" v-if="data.content.title">{{data.content.title}}</div>
					<div :style="'white-space: pre-wrap;line-height:25px;text-align:'+(data.content.textAlign?data.content.textAlign:'center')+';'" v-if="data.content.text" v-html="data.content.text"></div>
					<div class="pop-box-body-bottom" v-if="data.content.info" v-html="data.content.info"></div>
				</div>
			</div>
			
			<div class="dialog-button-group" v-if="data.confirm | data.cancel">
				<dy-button style="margin-right:10px;"
					:class="{'active':true, 'dialog-button-other':true, disable:data.disable || data.confirmDisable == true}" 
					:disable="data.disable || data.confirmDisable == true"
					:style="(data.bottomText ? 'margin-left:300px' : '')"
					v-if="data.other" 
					@click="other">{{data.otherText}}</dy-button>
					
				<dy-button 
					:class="{'active':true, 'dialog-button-confirm':true, disable:data.disable || data.confirmDisable == true}" 
					:disable="data.disable || data.confirmDisable == true"
					:style="(data.bottomText ? 'margin-left:300px' : '')"
					v-if="data.confirm" 
					@click="confirm">{{data.confirmText}}</dy-button>
					
				<a :class="{'dialog-button-cancel':true}" v-if="data.cancel" @click="cancel">{{data.cancelText}}</a>
				<a :class="{'dialog-button-right':true}" 
					v-if="data.rightButton" @click="data.rightButtonClick();">{{data.rightText}}</a>
				<span v-if="data.rightSelect" :class="{'dialog-right-select':true,'dialog-button-right':true}" @click="data.rightButtonClick()">
					<dy-checkbox :modelValue="data.rightSelectValue" ></dy-checkbox>
					{{data.rightText}}</span>
				<span class="bottom-text" v-if="data.bottomText" >{{data.bottomText}}</span>
			</div>
		</div>
	</div>	
</template>
<script>
	export default {
		name:"dy-dialog",
		data(){
			return{
				visible:false,
				data:{
					maskClick:true,
					confirm:true,
					confirmText:'我知道了',
					bottomText:'',
					rightText:'',
					disable:false,
					confirmDisable:false,
					cancel:false,
					cancelText:'取消',
					other:false,
					otherText:'',
					title:'',
					fit:false,
					width:0,
					height:0,
					content:null,
					data:{percent:0},
				},
				search_word:'',
			}
		},
		methods:{
			confirm(){
				if(this.data.disable) return;
				// console.log('confirm');
				if(this.data.success) {
					if(!this.data.success({confirm:true, data:this.data})) this.close();
				} else {
					this.close();
				}
			},
			cancel(e, mask){
				if(this.data.disable || (mask && !this.data.maskClick)) return;
				if(this.data.success) {
					if(!this.data.success({cancel:true})) this.close();
				} else {
					this.close();
				}
			},
			other(){
				if(this.data.disable) return;
				if(this.data.success) {
					if(!this.data.success({other:true, data:this.data})) this.close();
				} else {
					this.close();
				}
			},
			
			close(force){
				this.dyEditor.isDialog = false;
				if(this.data.disable && !force) return;
				if(this.data.hotkey != false){
					this.dyEditor.hotkey.remove('esc', this.close);
					this.dyEditor.hotkey.remove('enter', this.confirm);
				}
				this.visible = false;
				this.data = {};
				uni.$emit('dialog-close');
				this.$nextTick(()=>{
					this.data.onClose && this.data.onClose(this.data);
				});
			},
			update(option){
				if(!option.title)				option.title = '';
				if(option.confirm == undefined)	option.confirm = true;
				if(!option.confirmText)			option.confirmText = '我知道了';
				if(option.cancel == undefined) 	option.cancel = false;
				if(!option.cancelText)			option.cancelText = '取消';
				this.data = option;
			},
			show(option){
				this.dyEditor.hotkey.current = 'dialog';
				this.dyEditor.isDialog = true;
				this.visible = true;
				this.update(option);
				uni.$emit('dialog-show');
				if(this.data.hotkey != false){
					this.dyEditor.hotkey.on('esc', this.close);
					this.dyEditor.hotkey.on('enter', this.confirm);
				}
				this.search_word = '';
				this.$nextTick(()=>{
					option.onShow && option.onShow(option);
				});
			},
			enable(){
				this.data.disable = false;
			},
			disable(){
				this.data.disable = true;
			},
			enableConfirm(){
				this.data.confirmDisable = false;
			},
			disableConfirm(){
				this.data.confirmDisable = true;
			}
		}
	}
</script>

<style>
	.mask{
		background-color:rgba(0,0,0,0.5);
	}
	.dialog{
		margin:auto;
		/* margin-top: 30px; */
		min-width: 500px;
		min-height:350px;
		max-height: calc(100% - 60px);
		background-color:#232323;
		color: #dfdfdf;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		box-sizing: border-box;
		border-radius: 25px;
		z-index: 101;
		animation-duration: .3s;
		overflow:hidden;
	}
	.dialog.fit{
		width:calc(100% - 60px) !important;
		height:calc(100% - 60px) !important;
		margin:30px;
	}
	.dialog-title{
		height: 60px;
		line-height: 60px;
		width: 100%;
		padding: 0 20px;
		padding-right:0;
		box-sizing: border-box;
		font-size: 18px;
		display: flex;
		justify-content:flex-start;
		align-items: center;
		background-color:#292929;
	}
	.dialog-subtitle{
		font-size: 12px;
		color: rgb(250,108,14);
		margin-left: 10px;
		/* flex:1; */
	}
	.dialog-container{
		min-height: 50px;
		/* margin:0 20px; */
		box-sizing: border-box;
		font-size: 14px;
		color:#dfdfdf;
		text-align: center;
		/* border-top: 1px solid #efefef; */
		flex:1;
		display:flex;
		align-content: center;
		justify-content: center;
		align-items: center;
		line-height:20px;
		flex-direction: column;
		overflow:auto;
	}
	.dialog-container >>> .title{
		/* text-align: center; */
		font-size:18px;
		margin:10px;
		margin-bottom:15px;
	}
	
	.dialog-container >>> .content{
		/* text-align: center; */
		font-size:12px;
		margin:10px;
	}
	
	.dialog-button-group{
		/* border-top: 1px solid #2f2f2f; */
		height:60px;
		line-height:60px;
		text-align: center;
		padding-right:10px;
		box-sizing: border-box;
		position: relative;
		margin:0 20px;
	}
	.dialog-button-group .button{
		display:inline-block;
		max-width: 200px;
		min-width:120px;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
		vertical-align: middle;
	}
	.button_close{
		width: 30px;
		height: 30px;
		margin: 15px 10px;
		line-height: 30px;
		text-align: center;
		font-size:16px;
		color: #909090;
		cursor:pointer;
	}
	.button_close:hover{
		color:#808080 !important;
	}
	.button_close:active{
		color: #909090;
	}
	.dialog-button-cancel{
		position: absolute;
		left:0;
		color: #909090;
		cursor:pointer;
		font-size:14px;
		height:60px;
		line-height:60px;
	}
	.dialog-button-cancel:hover{
		color:#808080;
	}
	.dialog-button-cancel:active{
		color:#909090;
	}
	.dialog-button-right{
		position: absolute;
		right:0;
		/* color: #909090; */
		cursor:pointer;
		font-size:14px;
		height:60px;
		line-height:60px;
	}
	.dialog-button-right:active{
		color: #182ac6;
	}
	.dialog-right-select{
		color: #909090;
		display: inline-flex;
	}
	.dialog-button-group >>> .disable{
		background-color:#909090 !important;
	}
	.bottom-text{
		width: 300px;
		float: right;
		text-align: right;
	}
	.dialog-container >>> div::-webkit-scrollbar-thumb {
	    border-radius: 10px;
	    background-color: #333 !important;
	}
	.dialog-title-button{
		/* width:90px; */
		height:30px;
		line-height: 30px;
		font-size:14px;
		/* color:#909090; */
		cursor:pointer;
	}
	.dialog-title-button:hover{
		color:#dfdfdf;
	}
	.dialog-title-button i {
		color: #909090;
	}
	
	.dialog-title-button:hover i{
		color:#dfdfdf;
	}
	.title-input{
		width: 150px;
		height: 30px;
		line-height: 30px;
		border: 1px solid #efefef;
		font-size: 12px;
		padding: 0 5px;
		box-sizing: border-box;
		margin-right: 5px;
		background-color:#fff;
		color:#333;
	}
	.title-text-btn{
		background-color: rgba(0,0,0,0) !important;
		border: none;
		color: rgb(99, 120, 231);
	}
	.title-text-btn:first-of-type{
		margin-left:20px;
	}
	.title-text{
		width: 300px;
		height: 30px;
		line-height: 30px;
		flex: 1;
		text-align: center;
		font-size: 14px;
	}
	.title-text span{
		box-sizing: border-box;
		user-select : text;
	}
	.onlyImg{
		margin: 0;
		justify-content: flex-start;
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
	}
</style>
